import DetailedChip from './DetailedChip.container';

export default DetailedChip;
